import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Hourglass = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.7 21h12.6M5.7 3h12.6m-1.8 18v-3.755a1.8 1.8 0 0 0-.527-1.272L12 12m0 0-3.972 3.973a1.8 1.8 0 0 0-.528 1.272V21m4.5-9L8.028 8.027A1.8 1.8 0 0 1 7.5 6.755V3m4.5 9 3.973-3.973a1.8 1.8 0 0 0 .527-1.272V3"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Hourglass) as SvgIcon;
export { ForwardRef as ReactComponent };
